import Form     from 'scripts/poppet/form';
import template from 'templates/userEmailForm.jst.html';

const UserEmailForm = Form.extend( {
	template       : template,
	submitReaction : 'close',
	
	ui: {
		email1: '[data-input=update-email-1]',
		email2: '[data-input=update-email-2]',
		emails: '[data-input^=update-email-]',
		alreadyWarning: '[data-element=already-warning]'
	},
	
	onRender: function () {
		this.ui.email1.one( 'input', () => {
			this.ui.email2.parent().removeClass( 'hidden' ).addClass( 'fade-in' );
			this.ui.email2.removeClass('disabled');
		} );
		let warning = this.model.get('transientEmailVerification');
		if(warning) {
			this.ui.alreadyWarning.text(warning);
		}
	},
	
	submit: function () {
		this.model.saveEmail( {
			email: this.ui.email1.val().trim()
		} );
	}
	
} );

export default UserEmailForm;